package com.downdogapp.client.widget

import com.downdogapp.*
import com.downdogapp.client.resources.Images
import com.downdogapp.client.resources.image
import com.downdogapp.client.singleton.Cast
import com.downdogapp.client.singleton.CastState.*
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLImageElement

class CastButton(parent: HTMLDivElement,
                 clickFn: () -> Unit) {

  private var button: HTMLImageElement

  init {
    parent.apply {
      button = imageButton(width = 50, height = 50, clickFn = clickFn)
    }
    updateImage()
  }

  fun updateImage() {
    val image = when (Cast.castState) {
      NO_DEVICES_AVAILABLE -> null
      NOT_CONNECTED -> Images.CAST_NOT_CONNECTED
      CONNECTING -> Images.CAST_CONNECTING_0
      CONNECTED -> Images.CAST_CONNECTED
    }
    if (image == null) {
      button.hide()
    }
    button.image = image
  }
}

fun HTMLDivElement.castButton(clickFn: () -> Unit) = CastButton(this, clickFn)
